import React from 'react';
import BaseHeading from '@lululemon/ecom-pattern-library-heading';
var Heading = props => {
  return /*#__PURE__*/React.createElement(BaseHeading, props);
};
export default Heading;